import { render, staticRenderFns } from "./DocumentsLink.vue?vue&type=template&id=00ab289e"
import script from "./DocumentsLink.vue?vue&type=script&lang=js"
export * from "./DocumentsLink.vue?vue&type=script&lang=js"
import style0 from "./DocumentsLink.vue?vue&type=style&index=0&id=00ab289e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports